import {
  Component,
  OnInit,
} from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";

@Component({
  selector: 'app-op-markets',
  templateUrl: './op-markets.component.html',
  styleUrls: ['./op-markets.component.scss']
})
export class OpMarketsComponent implements OnInit {
  providerId;
  eventId = "";
  eventName = "";
  sportId;
  searchKey = "";
  status = "";
  sportName: string = "";
  openDate = 0;
  filteredMarkets = [];
  marketsList = [];
  startDate: null;
  endDate: null;

  openMarketsTableColumns = [
    "Created At",
    "Market Id",
    "Event Id",
    "Market Name",
    "Event Name",
    "Market Status",
    "Result",
  ];

  settledMarketColums = [
    "Created At",
    "Market Id",
    "Market Name",
    "Result",
    "Result Time"
  ];
  voidedMarketColumns = ["Created At", "Market Id", "Market Name","Reason","Voided Time"];

  constructor(
    private appService: AppService,
    private router: Router,
    private activetedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.activetedRoute.queryParams.subscribe((params) => {
      this.providerId = params["providerId"];
      this.sportId = params["sportId"];
      this.eventId = params["eventId"];
      this.eventName = params["eventName"];
      this.sportName = params["sportName"];
      this.openDate = parseInt(params["openDate"]);
      this.startDate  = params["startDate"]
      this.endDate  = params["endDate"]
    });

    this.getEvetDetails();
  }

  getEvetDetails() {
    try {
      this.appService
        .getMarketsForOP(
          this.eventId,
          this.sportId,
          this.providerId
        )
        .subscribe((response) => {
          if (response.status === "RS_OK") {
            this.marketsList = response.markets
            this.filteredMarkets = this.marketsList
          }
        });
    } catch (err) {
      console.log(err);
    }
  }
  onSelectedStatusChange(status) {
    this.searchKey = "";
    this.status = status;
  }

  searchHandlerChange() {
      if (this.searchKey.length >= 1) {
        this.filteredMarkets = this.marketsList.filter((market) => {
          if (
            market.marketName
              .toLocaleLowerCase()
              .includes(this.searchKey.toLocaleLowerCase())
          ) {
            return market;
          }
        });
      } else {
        this.filteredMarkets = this.marketsList;
      }
  }

  goBack() {
    this.router.navigate(["surveillance/events"], {
      queryParams: {
        providerId: this.providerId,
        sportId: this.sportId,
        sportName: this.sportName,
        startDate: this.startDate,
        endDate: this.endDate,
      },
    });
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

}
